// Reads runtime config from window.__env (populated by /env.js).
// All values have safe fallbacks for `npm run dev`.

const env = (typeof window !== 'undefined' && window.__env) || {};

export const config = {
  apiUrl: env.BACKEND_API_URL || 'http://localhost:5000/api/v1.0',
  heartbeatSeconds: Number(env.HEARTBEAT_SECONDS) || 60,
  syncMinutes: Number(env.SYNC_MINUTES) || 30,
  batchSize: Number(env.BATCH_SIZE) || 10,
  pwaVersion: env.PWA_VERSION || '0.1.0'
};
